import React from 'react';
import PropTypes from 'prop-types';

const UploadButton = ({ children, onChange }) => (
  <label className="c-file-input c-file-input--membership u-float-left" htmlFor="subscriptionsImportFile">
    <span>{children}</span>
    <input
      type="file"
      className="is-hidden"
      onChange={onChange}
      name="csv"
      accept=".csv"
      id="subscriptionsImportFile"
    />
  </label>
);

UploadButton.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UploadButton;
